import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import SEOHead from "@/components/SEOHead";
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const location = useLocation();
  const { i18n } = useTranslation();
  const [funnyMessage, setFunnyMessage] = useState("");
  
  // Collection of humorous 404 messages
  const funnyMessages = [
    "Looks like this page took a vacation without telling anyone.",
    "This page is playing hide and seek. It's winning.",
    "Houston, we have a problem. Page not found in our orbit.",
    "Our developer might have spilled coffee on this URL.",
    "404: Page got lost in the digital wilderness.",
    "This link appears to be on a digital sabbatical.",
    "The page you requested has been moved to the cloud. Literally.",
    "You've reached the edge of the internet. Turn back now.",
  ];

  useEffect(() => {
    // Log the error for tracking
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
    
    // Choose a random funny message
    const randomIndex = Math.floor(Math.random() * funnyMessages.length);
    setFunnyMessage(funnyMessages[randomIndex]);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-background to-muted/50 px-4">
      <SEOHead
        title="404 - Page Not Found"
        description="The page you're looking for could not be found. Return to the homepage or explore other sections of the site."
        canonical={`https://impelatek.fr${location.pathname}`}
        lang={i18n.language}
      />
      <div className="max-w-md w-full bg-card rounded-lg shadow-xl p-8 border border-border">
        <div className="text-center space-y-6">
          <div className="animate-pulse">
            <h1 className="text-[120px] font-bold text-primary leading-tight tracking-tighter">404</h1>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold text-foreground">Page Not Found</h2>
            <p className="mt-2 text-muted-foreground">{funnyMessage}</p>
          </div>
          
          <div className="h-px w-full bg-border my-6"></div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button variant="default" size="lg" onClick={() => window.history.back()}>
              Go Back
            </Button>
            <Button variant="outline" size="lg" asChild>
              <a href="/">Return Home</a>
            </Button>
          </div>
          
          <p className="text-sm text-muted-foreground pt-6">
            If you believe this is a mistake, please contact support.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
